import React, { useEffect, useRef, useState } from 'react';
import { MachinePlayer, phaseTimeRange, estimateCyclePosition } from './machineModelEngine';

/* 사출기 동작 모델 (SEORO-machine-demo 프레임을 재생)
 *
 * 재생 위치는 실제 설비를 따라간다:
 * - 가동중 + 추정 가능: 사이클 안 추정 위치(단계 + 진행률)에 해당하는 타임라인 시점으로 매 프레임 이동
 * - 가동중 + 추정 불가(사이클타임·마지막 샷 없음): 데모와 같은 속도로 반복 재생
 * - 대기·정지: 형폐 대기 프레임(타임라인 0초)에 고정
 * 프레임 데이터(약 1MB)는 이 컴포넌트가 처음 마운트될 때 동적 import 로 한 번만 내려받는다. */

let statesPromise = null;
const loadStates = () => {
  if (!statesPromise) statesPromise = import('./machineStates').then((m) => m.default);
  return statesPromise;
};

function MachineModel({ running, lastShotMs, cycleSec, durations, label, loadingText }) {
  const boxRef = useRef(null);
  const inputRef = useRef({ running, lastShotMs, cycleSec, durations });
  inputRef.current = { running, lastShotMs, cycleSec, durations };
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let raf = 0;
    let player = null;
    let freeStartMs = null;

    loadStates()
      .then((states) => {
        if (cancelled || !boxRef.current) return;
        player = new MachinePlayer(boxRef.current, states);
        setReady(true);

        const tick = (now) => {
          const input = inputRef.current;
          let time = 0;
          if (input.running) {
            const pos = estimateCyclePosition(Date.now(), input.lastShotMs, input.cycleSec, input.durations || {});
            if (pos) {
              const [start, end] = phaseTimeRange(player.timeline, pos.idx);
              time = start + pos.progress * (end - start);
              freeStartMs = null;
            } else {
              if (freeStartMs == null) freeStartMs = now;
              time = ((now - freeStartMs) / 1000) % player.timeline.total;
            }
          } else {
            freeStartMs = null;
          }
          player.drawAt(time);
          raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
      })
      .catch((err) => console.error('machine model load failed:', err));

    return () => {
      cancelled = true;
      cancelAnimationFrame(raf);
      if (player) player.destroy();
    };
  }, []);

  return (
    <div className="ov-model">
      <div ref={boxRef} className="ov-model-stage" role="img" aria-label={label} />
      {!ready && <span className="ov-model-loading">{loadingText}</span>}
    </div>
  );
}

export default MachineModel;
